import auth from '../../middlewares/auth';

export const licenseRoutes = [
  {
    path: '/licenses',
    component: () =>
      import(/* webpackChunkName: "licenses" */ '../../views/licenses/License'),
    name: 'licenses',
    meta: {
      middleware: [auth],
      requiredPermissions: ['license-manage'],
    },
  },
  {
    path: '/license/:id',
    component: () =>
      import(
        /* webpackChunkName: "licenses" */ '../../views/licenses/LicenseForm'
      ),
    name: 'update-license',
    meta: {
      middleware: [auth],
      requiredPermissions: ['license-manage'],
    },
  },
  {
    path: '/create-license',
    component: () =>
      import(
        /* webpackChunkName: "licenses" */ '../../views/licenses/LicenseForm'
      ),
    name: 'create-license',
    meta: {
      middleware: [auth],
      requiredPermissions: ['license-manage'],
    },
  },
];
